module.exports = __webpack_public_path__ + "assets/img/report-wealth-img.4faa8255.png";